export class SuppliersModel {
	constructor(
		public id: string,
		public name: string,
		public contact: string,
		public address: string,
		public phone: string,
		public fax: string
	) { }
}

export class SupplierModel {
	constructor(
		public id: string = '',
		public name: string = '',
		public contact: string = '',
		public address: string = '',
		public phone: string = '',
		public fax: string = ''
	) {
		this.id = id;
		this.address = address;
		this.contact = contact;
		this.fax = fax;
		this.phone = phone;
		this.name = name;
	}
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/suppliers.model.ts